// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCGMPRkrDr5yMIqaxiCQXrq-pY0_Ug57Ls",
  authDomain: "evosurvey.firebaseapp.com",
  projectId: "evosurvey",
  storageBucket: "evosurvey.firebasestorage.app",
  messagingSenderId: "795950092325",
  appId: "1:795950092325:web:06d1777e2ca0ab00acafcc",
  measurementId: "G-F8E1RXRSWP"
};
  


const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app, 'evoosurveyreports')
export const storage = getStorage(app) // <-- Storage referansı